
const zoomsize = 0.8;
// {
//   name: "Type (3)b",
//     type: "B1-G",
//       color: "#FFF9B8",
//         imgnames: 4,
//           typecls: [
//             { 
//               cttype: true, // 定制模型、指定模型其他图片
//               w: '5%', 
//               h: '14.5%', 
//               x: '43%', 
//               y: '36%', 
//               color: '#D4EFFC', 
//               type: "3b", 
//               ctname: "TYPE-3b_1" 
//             }
//             ]
// },

const unit_type_list = [
  {
    name: "2 Bedroom", color: "#67a7a0", to_type: [
      {
        name: "TYPE B (BLK 38)", type: "B", color: "#67a7a0", imgnames: 0, typecls: [
          { w: '5%', h: '17%', x: '60.5%', y: '36%', color: '#D4EFFC', type: "B", ctname: "B" }
        ]
      },
      {
        name: "TYPE B (BLK 42)", type: "B", color: "#67a7a0", imgnames: 35, typecls: [
          { w: '2.5%', h: '18%', x: '43%', y: '35%', color: '#D4EFFC', type: "B", ctname: "B-1" }
        ]
      },
    ]
  },
  {
    name: "2 Bedroom Premium", color: "#a1c3c0", to_type: [
      {
        name: "TYPE BP-1", type: "BP-1", color: "#a1c3c0", imgnames: 0, typecls: [
          { w: '4.5%', h: '15.7%', x: '42%', y: '36%', color: '#D4EFFC', type: "BP-1", ctname: "BP1" }

        ]
      },
      {
        name: "TYPE BP-2 (BLK 40)", type: "BP-2", color: "#a1c3c0", imgnames: 35, typecls: [
          { w: '2.5%', h: '15%', x: '56.3%', y: '35%', color: '#D4EFFC', type: "BP-2", ctname: "BP2" }

        ]
      },
      {
        name: "TYPE BP-2 (BLK 42)", type: "BP-2", color: "#a1c3c0", imgnames: 0, typecls: [
          { w: '1.8%', h: '13%', x: '51.5%', y: '36%', color: '#D4EFFC', type: "BP-2", ctname: "BP2-1" }

        ]
      },
    ]
  },
  {
    name: "2 Bedroom Premium + Study", color: "#bfd6d3", to_type: [
      {
        name: "TYPE BS", type: "BS", color: "#bfd6d3", imgnames: 29, typecls: [
          { w: '4.1%', h: '15%', x: '35.2%', y: '35.2%', color: '#D4EFFC', type: "BS", ctname: "BS" }

        ]
      },
    ],
  },
  {
    name: "3 Bedroom", color: "#94889d", to_type: [
      {
        name: "TYPE C-1 (BLK 40)", type: "C-1", color: "#94889d", imgnames: 34, typecls: [
          { w: '2.4%', h: '14.8%', x: '55%', y: '35%', color: '#D4EFFC', type: "C-1", ctname: "C1" }
        ]
      },
      {
        name: "TYPE C-1 (BLK 42)", type: "C-1", color: "#94889d", imgnames: 63, typecls: [
          { w: '2%', h: '12.7%', x: '52.8%', y: '36%', color: '#D4EFFC', type: "C-1", ctname: "C1-1" }
        ]
      },
      {
        name: "TYPE C-2", type: "C-2", color: "#94889d", imgnames: 0, typecls: [
          { w: '4.1%', h: '17%', x: '64.3%', y: '36%', color: '#D4EFFC', type: "C-2", ctname: "C2" }

        ]
      },
      {
        name: "TYPE C-3", type: "C-3", color: "#94889d", imgnames: 35, typecls: [
          { w: '3.8%', h: '15%', x: '58%', y: '35%', color: '#D4EFFC', type: "C-3", ctname: "C3" }

        ]
      },
    ],
  },
  {
    name: "3 Bedroom Premium", color: "#c0bfd2", to_type: [
      {
        name: "TYPE CP-1", type: "CP-1", color: "#c0bfd2", imgnames: 29, typecls: [
          { w: '3.5%', h: '15.5%', x: '32.7%', y: '35%', color: '#D4EFFC', type: "CP-1", ctname: "CP1" }

        ]
      },
      {
        name: "TYPE CP-2", type: "CP-2", color: "#c0bfd2", imgnames: 0, typecls: [
          { w: '3.8%', h: '17%', x: '57.5%', y: '36%', color: '#D4EFFC', type: "CP-2", ctname: "CP2" }

        ]
      },
      {
        name: "TYPE CP-3", type: "CP-3", color: "#c0bfd2", imgnames: 29, typecls: [
          { w: '3.5%', h: '15.2%', x: '32.6%', y: '35%', color: '#D4EFFC', type: "CP-3", ctname: "CP3" }

        ]
      },
      {
        name: "TYPE CP-4", type: "CP-3", color: "#c0bfd2", imgnames: 0, typecls: [
          { w: '3.3%', h: '15.8%', x: '39.5%', y: '36%', color: '#D4EFFC', type: "CP-4", ctname: "CP4" }

        ]
      },
    ],
  },
  {
    name: "4 Bedroom", color: "#f18849", to_type: [
      {
        name: "TYPE D-1", type: "D-1", color: "#f18849", imgnames: 35, typecls: [
          { w: '3.5%', h: '15%', x: '58.2%', y: '35%', color: '#D4EFFC', type: "D-1", ctname: "D1" }
        ]
      },
      {
        name: "TYPE D-2", type: "D-2", color: "#f18849", imgnames: 0, typecls: [
          { w: '3.5%', h: '17%', x: '46%', y: '36%', color: '#D4EFFC', type: "D-2", ctname: "D2" }
        ]
      },
    ],
  },
  {
    name: "4 Bedroom Dual-Key", color: "#f5a16c", to_type: [
      {
        name: "TYPE DK", type: "DK", color: "#f5a16c", imgnames: 20, typecls: [
          // { w: '2.7%', h: '17%', x: '46.6%', y: '34%', color: '#D4EFFC', type: "DK", ctname: "DK" }
          { w: '3%', h: '15.5%', x: '46.5%', y: '35.5%', color: '#D4EFFC', type: "DK", ctname: "DK" }
        ]
      },
    ],
  },
  {
    name: "4 Bedroom Premium + Private Lift", color: "#fac6a3", to_type: [
      {
        name: "TYPE DP-1", type: "DP-1", color: "#fac6a3", imgnames: 1, typecls: [
          { w: '3.2%', h: '13.8%', x: '49%', y: '36%', color: '#D4EFFC', type: "DP-1", ctname: "DP1" }

        ]
      },
      {
        name: "TYPE DP-2", type: "DP-2", color: "#fac6a3", imgnames: 62, typecls: [
          { w: '2.7%', h: '12.5%', x: '53.6%', y: '36%', color: '#D4EFFC', type: "DP-2", ctname: "DP2" }

        ]
      },
    ],
  },
  {
    name: "5 Bedroom + Private Lift", color: "#af8b8f", to_type: [
      {
        name: "TYPE E", type: "E", color: "#af8b8f", imgnames: 29, typecls: [
          { w: '4.2%', h: '14.5%', x: '38.6%', y: '35%', color: '#D4EFFC', type: "E", ctname: "E" }

        ],
      },

    ],
  },

]



const floorplan = {
  "A1": {name: 'TYPE A1', type: '1 - Bedroom', plan: require("@/assets/unit/A1.jpg"),color: "#8bb7b1"},
  "B1": {name: 'TYPE B1', type: '2 - Bedroom Deluxe', plan: require("@/assets/unit/B1.jpg"),color: "#b8afa6"},
  "B2": {name: 'TYPE B2', type: '2 - Bedroom Premium', plan: require("@/assets/unit/B2.jpg"),color: "#a09a8d"},
  "B3": {name: 'TYPE B3', type: '2 - Bedroom Premium', plan: require("@/assets/unit/B3.jpg"),color: "#a09a8d"},
  "C1": {name: 'TYPE C1', type: '3 - Bedroom Deluxe', plan: require("@/assets/unit/C1.jpg"),color: "#b8d0db"},
  "C2": {name: 'TYPE C2', type: '3 - Bedroom Premium', plan: require("@/assets/unit/C2.jpg"),color: "#80a6b6"},
  "C3": {name: 'TYPE C3', type: '3 - Bedroom Premium', plan: require("@/assets/unit/C3.jpg"),color: "#80a6b6"},
  "C4": {name: 'TYPE C4', type: '3 - Bedroom Premium (Private Lift)', plan: require("@/assets/unit/C4.jpg"),color: "#80a6b6"},
  "D1": {name: 'TYPE D1', type: '4 - Bedroom Premium', plan: require("@/assets/unit/D1.jpg"),color: "#e3e1ca"},
  "D2": {name: 'TYPE D2', type: '4 - Bedroom Premium (Private Lift)', plan: require("@/assets/unit/D2.jpg"),color: "#d2caa0"},
  "D2b": {name: 'TYPE D2b', type: '4 - Bedroom Premium (Private Lift)', plan: require("@/assets/unit/D2b.jpg"),color: "#d2caa0"},
  "DS": {name: 'TYPE DS', type: '4 - Bedroom Premium + Study', plan: require("@/assets/unit/DS.jpg"),color: "#a79b4b"},

}


const building = {
  "6C": {
    title: "6C Tanjong Rhu Road S (436885)",
    buildingData: [
      [{ name: "Unit / Level", unitname: "", color: "#ffffff00", type: "tab" }, { name: "01", unitname: "", color: "#ffffff00", type: "Stacks" }, { name: "02", unitname: "", color: "#ffffff00", type: "Stacks" }, { name: "03", unitname: "", color: "#ffffff00", type: "Stacks" },{ name: "04", unitname: "", color: "#ffffff00", type: "Stacks" }, ],
      [{ name: "20", unitname: "", color: "#ffffff00", type: "tab" }, { name: "", unitname: "", color: "#ffffff00", type: "tab", show: true },{ name: "", unitname: "", color: "#ffffff00", type: "tab", show: true },{ name: "DS", unitname: "DS", r:2, color: "#a79b4b", type: "unit", show: true },],
      [{ name: "19", unitname: "", color: "#ffffff00", type: "tab" }, { name: "", unitname: "", color: "#ffffff00", type: "tab", show: true },{ name: "B2b", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "D1", unitname: "D1", r:2, color: "#e3e1ca", type: "unit", show: true },],
      [{ name: "18", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1a", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2a", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1a", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1a", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "17", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "16", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "15", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "14", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "13", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "12", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "11", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "10", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "C1", unitname: "C1", color: "#b8d0db", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "09", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "08", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "07", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "06", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "05", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "04", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "03", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3", unitname: "B3", color: "#a09a8d", type: "unit", show: true },{ name: "A1", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      [{ name: "02", unitname: "", color: "#ffffff00", type: "tab" }, { name: "B1p", unitname: "B1", color: "#b8afa6", type: "unit", show: true },{ name: "B2p", unitname: "B2", color: "#a09a8d", type: "unit", show: true },{ name: "B3p", unitname: "C1", color: "#a09a8d", type: "unit", show: true },{ name: "A1p", unitname: "A1", color: "#8bb7b1", type: "unit", show: true },],
      
    ],
  },
  "6D": {
    title: "6D Tanjong Rhu Road S (436886)",
    buildingData: [
      [{ name: "Unit / Level", unitname: "", color: "#ffffff00", type: "tab" }, { name: "05", unitname: "", color: "#ffffff00", type: "Stacks" }, { name: "06", unitname: "", color: "#ffffff00", type: "Stacks" }],
      [{ name: "20", unitname: "", color: "#ffffff00", type: "tab" },{ name: "D2b", unitname: "D2b", color: "#d2caa0", type: "unit", show: true }, { name: "", unitname: "", color: "#ffffff00", type: "tab", show: true }],
      [{ name: "19", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C3", unitname: "C3", color: "#80a6b6", type: "tab", show: true },{ name: "", unitname: "", color: "#ffffff00", type: "tab", show: true }],
      [{ name: "18", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2a", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2a", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "17", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "16", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "15", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "14", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "13", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "12", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "11", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "10", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "09", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "08", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "07", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "D2", unitname: "D2", color: "#d2caa0", type: "unit", show: true }],
      [{ name: "06", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "C4", unitname: "C4", color: "#478195", type: "unit", show: true }],
      [{ name: "05", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "C4", unitname: "C4", color: "#478195", type: "unit", show: true }],
      [{ name: "04", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "C4", unitname: "C4", color: "#478195", type: "unit", show: true }],
      [{ name: "03", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "C4", unitname: "C4", color: "#478195", type: "unit", show: true }],
      [{ name: "02", unitname: "", color: "#ffffff00", type: "tab" }, { name: "C2p", unitname: "C2", color: "#80a6b6", type: "tab", show: true },{ name: "C4p", unitname: "C4", color: "#478195", type: "unit", show: true }],
      
    ],
  },
}

export default {
  unit_type_list,
  zoomsize,
  floorplan,
  building,
};





